// A drill-in is a detour: the operator left one page to look at something and
// expects to come straight back. Links that drill in carry the page they came
// from in router state, and the header turns that into "← Back to …".
//
// Router state, not a query string: it survives the browser's own Back and
// Forward, it is gone on a fresh load (where there is nothing to go back to),
// and it never puts internal routing into a URL someone shares.

export interface DrillInState {
  from: string;
}

/** `navigate(to, { state: drillInState(location.pathname) })` or `<Link state={…}>`. */
export function drillInState(from: string): DrillInState {
  return { from };
}

export function drilledInFrom(state: unknown): string | null {
  if (state && typeof state === "object" && "from" in state) {
    const from = (state as { from: unknown }).from;
    return typeof from === "string" && from.startsWith("/") ? from : null;
  }
  return null;
}
